import * as React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../hooks/userAuth";


type ProtectedRoutesProps = {
  isRestricted: boolean;
}


const ProtectedRoutes: React.FC<ProtectedRoutesProps> = () => {
  const auth = useAuth();
  return auth ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoutes;
